angular.module("NumbersEditor").filter('ToEventDesc', function () {
    return function (input) {
        switch (input) {
            case "I":
                return "Initial";
            case "A":
                return "Active";
            case "O":
                return "Released";
            case "R":
                return "Resulted";
            case "S":
                return "Suspended";
            case "P":
                return "Change Pending";
            case "V":
                return "Void";
            case "C":
                return "Cancelled";
            case "X":
                return "Resulted"; //Pre-Resulted
            default:
                return "STATUS DESC NOT FOUND";
        }
    };
});